












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Debouncer } from "@/models/Debouncer";
import { Parser } from "json2csv";

@Component({})
export default class extends Vue {
  private date = new Date();
  private fromDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  private toDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

  private totalSales = 0;
  private averageCover = 0;
  private tableTurnoverRate = 0;
  private totalTips = 0;
  private foodVsDrinks = [50, 50];
  private foodVsDrinksOptions = {
    labels: ["Food", "Drinks"]
  };
  private costsVsProfit = [50, 50];
  private costsVsProfitOptions = {
    labels: ["Costs", "Profit"]
  };
  private salesPerDayCategories = {
    xaxis: {
      categories: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ]
    }
  };
  private salesPerDayTotals = [
    {
      name: "Total sales per day",
      data: [0, 0, 0, 0, 0, 0, 0]
    }
  ];

  private items = [
    { icon: "fastfood", text: "Products / Menu", name: "products" },
    { icon: "grade", text: "Manage Promotions", name: "promotions" },
    { icon: "settings", text: "Floor Layout", name: "floorlayouts" },
    { icon: "table_chart", text: "Manage Tables", name: "tables" },
    { icon: "people", text: "Manage Staff", name: "admin_staff" },
    { icon: "restaurant", text: "Manage Orders", name: "orders" },
    { icon: "layers", text: "Table Assigments", name: "table_assigments" },
    { icon: "show_chart", text: "Reports", name: "reports" },
    {
      icon: "restaurant",
      text: "Restaurant Profile",
      name: "restaurant_profile"
    }
  ];

  public mounted() {
    this.loadData();
  }

  private async loadData() {
    try {
      const result = await app.reportService.getRestaurantSales(
        new Date(
          this.date.getFullYear(),
          this.date.getMonth(),
          this.date.getDate() - 6
        ),
        new Date(
          this.date.getFullYear(),
          this.date.getMonth(),
          this.date.getDate(),
          23,
          59,
          59
        )
      );
      this.totalSales = result.total_sales ? result.total_sales : 0;
    } catch (e) {
      console.log(e);
    }

    try {
      const result = await app.reportService.getAverageCover(
        this.fromDate,
        this.toDate
      );
      this.averageCover = result.average_cover ? result.average_cover : 0;
    } catch (e) {
      console.log(e);
    }

    try {
      const result = await app.reportService.getTableTurnoverRate(
        this.fromDate,
        this.toDate
      );
      this.tableTurnoverRate =
        result
          .map((a: any) => a.table_turnover)
          .reduce((x: any, y: any) => x + y, 0) / result.length || 0;
    } catch (e) {
      console.log(e);
    }

    try {
      const result = await app.reportService.getTotalTips(
        this.fromDate,
        this.toDate
      );
      this.totalTips = result.total_tips ? result.total_tips : 0;
    } catch (e) {
      console.log(e);
    }

    try {
      const result = await app.reportService.getSalesPerDay(
        this.fromDate,
        this.toDate
      );
      this.salesPerDayTotals = [
        {
          name: "Total sales per day",
          data: result.map((x: any) => +x.total_sales)
        }
      ];
      this.salesPerDayCategories = {
        xaxis: {
          categories: result.map((x: any) => new Date(x.date).toDateString())
        }
      };
    } catch (e) {
      console.log(e);
    }

    try {
      const result = await app.reportService.getCostsVsProfit(
        this.fromDate,
        this.toDate
      );
      this.costsVsProfit = [
        +result.total_costs,
        +result.total_sales - +result.total_costs
      ];
    } catch (e) {
      console.log(e);
    }

    try {
      const result = await app.reportService.getFoodVsDrinks(
        this.fromDate,
        this.toDate
      );
      this.foodVsDrinks = result.map((x: any) => +x.total_sales);
    } catch (e) {
      console.log(e);
    }
  }
}
